import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { DisplayDateWithTimezonePipe } from './display-date-with-timezone.pipe';
import { FormateDatePipe } from './formate-date.pipe';

@NgModule({
  declarations:[FilterPipe, SearchPipe, ShortNamePipe,DisplayDateWithTimezonePipe, FormateDatePipe],
  imports:[CommonModule],
  exports:[FilterPipe, SearchPipe, ShortNamePipe,DisplayDateWithTimezonePipe,FormateDatePipe]
})

export class PipeModule{}
